import { plural } from '@cian/utils';

import { IOffer } from '../../../../types/offerData';

type IGetCommercialMultiAdsFloorConfig = (building: IOffer) => [string, string];

export const getCommercialMultiAdsFloorConfig: IGetCommercialMultiAdsFloorConfig = offer => {
  const floorsCount = offer.building?.floorsCount || offer.floorNumber;

  const pluralizedFloor = plural(floorsCount, ['Этаж', 'Этажа', 'Этажей']);

  return [pluralizedFloor, `${floorsCount}`];
};
